import { Box, Code, Divider, Link, ListItem, OrderedList, Text, UnorderedList } from '@chakra-ui/react';

import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownTextProps {
  content: string;
}

const markdownComponents: Components = {
  p: ({ children }) => (
    <Text fontSize="14px" lineHeight="20px" fontWeight={500} color="baseBlack" mb={2} _last={{ mb: 0 }}>
      {children}
    </Text>
  ),
  strong: ({ children }) => (
    <Text as="strong" fontWeight={700}>
      {children}
    </Text>
  ),
  em: ({ children }) => <Text as="em">{children}</Text>,
  ul: ({ children }) => (
    <UnorderedList fontSize="14px" fontWeight={500} color="baseBlack" pl={4} mb={2} spacing={1}>
      {children}
    </UnorderedList>
  ),
  ol: ({ children }) => (
    <OrderedList fontSize="14px" fontWeight={500} color="baseBlack" pl={4} mb={2} spacing={1}>
      {children}
    </OrderedList>
  ),
  li: ({ children }) => <ListItem>{children}</ListItem>,
  code: ({ children }) => (
    <Box
      as="pre"
      fontSize="13px"
      backgroundColor="neutral.100"
      borderRadius="6px"
      p={3}
      mb={2}
      overflowX="auto"
      whiteSpace="pre"
    >
      <Code backgroundColor="transparent">{children}</Code>
    </Box>
  ),
  a: ({ href, children }) => (
    <Link href={href} color="blue.500" isExternal textDecoration="underline">
      {children}
    </Link>
  ),
  hr: () => <Divider my={3} />,
  h1: ({ children }) => (
    <Text as="h1" fontSize="16px" fontWeight={700} color="baseBlack" mb={2}>
      {children}
    </Text>
  ),
  h2: ({ children }) => (
    <Text as="h2" fontSize="15px" fontWeight={700} color="baseBlack" mb={2}>
      {children}
    </Text>
  ),
  h3: ({ children }) => (
    <Text as="h3" fontSize="14px" fontWeight={700} color="baseBlack" mb={2}>
      {children}
    </Text>
  ),
};

export default function MarkdownText({ content }: MarkdownTextProps) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
      {content}
    </ReactMarkdown>
  );
}
